import { api as dragoonApi } from '@apis/dragoon/api';
import { api as fistoApi } from '@apis/fisto/api';
import { api as rammanApi } from '@apis/ramman/api';
import { api as rioblastApi } from '@apis/rioblast/api';
import { combineReducers } from 'redux';

import alerts from './alerts/reducer';
import dataSetConfigs from './dataSetConfigs/reducer';
import filters from './filters/reducer';
import riskMatrix from './riskMatrix/reducer';
import session from './session/reducer';
import settings from './settings/reducer';
import { apiSkeletor } from './skeletor/skeletorApi';
import user from './user/reducer';

const rootReducer = combineReducers({
  session,
  user,
  settings,
  filters,
  alerts,
  riskMatrix,
  dataSetConfigs,
  [apiSkeletor.reducerPath]: apiSkeletor.reducer,
  [rammanApi.reducerPath]: rammanApi.reducer,
  [rioblastApi.reducerPath]: rioblastApi.reducer,
  [dragoonApi.reducerPath]: dragoonApi.reducer,
  [fistoApi.reducerPath]: fistoApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
